import { Card, Divider, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ReactTimeAgo from "react-time-ago";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./Home.module.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import Button from "../../Subcomponents/Button";
import AllotmentBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import AllotmentprofileIcon from "../../Assets/Images/Common/AllotmentProfile.svg";
import AllotmentCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import AllotmentInfoIcon from "../../Assets/Images/Common/info-circle.svg";
import CancelUnit from "../../Modals/CancelUnit.js/CancelUnit";
import AllotmentDetails from "../AllotmentDetails/AllotmentDetails";
import AllotmentPayment from "../../Modals/AllotmentPayment/AllotmentPayment";
import { createPaymentOrder, getPaymentLinkMode, getPyamentLink, paymentEntry, sdrPaymentMode } from "../../Services/Allotment";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, successTost } from "../../Services/Toast";
import { Tooltip } from "react-tooltip";
import BookingForm from "../../Modals/BookingForm/BookingForm";
import UnitCost from "../../Modals/UnitCost/UnitCost";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import { getAllotmentCancelledTransaction } from "../../Services/ChangeUnitRequest";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import PaymentGatewaySelection from "../../Modals/PaymentGateway/PaymentGatewaySelection";
import usePaymentConsent, { allotmentConsentSummary } from "../../Modals/PaymentConsent/usePaymentConsent";
import { CONSENT_TYPES } from "../../Services/Consent";
import useAllotmentEsign from "../../Modals/AllotmentEsign/useAllotmentEsign";
import useEsignFlow from "../../Modals/AllotmentEsign/useEsignFlow";
import { kycFirstPayNowHidden, payNowNeedsEsign, kycButtonLabel, KYC_FIRST_TEXT } from "../../Modals/AllotmentEsign/preselectKyc";
import useCrm2Booking from "./Crm2/useCrm2Booking";
import ShortlistedSteps from "./Crm2/ShortlistedSteps";
import WaitingForRm from "./Crm2/WaitingForRm";
import Crm2PaymentSuccess from "./Crm2/PaymentSuccess";
import crm2Css from "./Crm2/Crm2Booking.module.css";

const Allotment = ({ allotment, handleNext, serverTime }) => {
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	const { requireConsent, consentModal } = usePaymentConsent();
	const { requireEsign, esignModal } = useAllotmentEsign();
	const esignFlow = useEsignFlow().newFlow(allotment?.allotmentPaymentId);
	// CRM 2.0 (M2-F9): Shortlisted steps, "assigning your Relationship Manager", Payment successful. null for old bookings.
	const crm2 = useCrm2Booking(allotment);
	const crm2State = crm2?.bookingState;
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const [pendingTransaction, setPendingTransaction] = useState([]);
	const [currentAllotmentPayment, setCurrentAllotmentPayment] = useState(null);
	const [openBookingFormModal, setOpenBookingFormModal] = useState(false);

	const [allotmentDetails, setAllotmentDetails] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [openAllotmentPartialPaymentModal, setOpenAllotmentPartialPaymentModal] = useState(false);
	const [openCancelUnitModal, setOpenCancelUnitModal] = useState(false);
	const [showUnitCost, setShowUnitCost] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [isTimerFinished, setIsTimerFinished] = useState(false);
  const [openPaymentGatewaySelectionModal, setOpenPaymentGatewaySelectionModal] = useState(false);
  const [payableAmount, setPayableAmount] = useState(0);
  
  const isMobile = useMediaQuery("(max-width:600px)");

	  useEffect(() => {
    if (!allotment?.expiryTime) return; // ⛔ Do nothing if expiryTime not available

    const intervalId = setInterval(() => {
      const currentTime = Date.now(); // Current time in ms
      const timeDiff = allotment.expiryTime - currentTime;

      if (timeDiff <= 0) {
        clearInterval(intervalId);
        setIsTimerFinished(true);
        setTimeRemaining("00:00");
      } else {
        // Convert to minutes and seconds
        const totalSeconds = Math.floor(timeDiff / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Format mm:ss (pad with zeros)
        const formattedTime = `${String(minutes).padStart(2, "0")} min: ${String(
          seconds
        ).padStart(2, "0")} sec`;

        setTimeRemaining(formattedTime);
      }
    }, 1000);

    // Cleanup interval when component unmounts or expiryTime changes
    return () => clearInterval(intervalId);
  }, [allotment?.expiryTime]);


	useEffect(() => {
		if (Object.keys(allotmentDetails).length > 0 && showModal && !showDetails) {
			if (
				allotmentDetails.AllotmentTransactions.filter((ele) => {
					return ele.status === "pending";
				}).length > 0
			) {
				setPendingTransaction((pre) => {
					pre.push(
						allotmentDetails.AllotmentTransactions.filter((ele) => {
							return ele.status === "pending";
						})[0]
					);
					return [...pre];
				});
			} else {
				setOpenAllotmentPartialPaymentModal(true);
			}
		}
	}, [allotmentDetails, showModal, showDetails]);
	useEffect(() => {
		if (pendingTransaction.length > 0) {
			setOpenAllotmentPartialPaymentModal(true);
		}
	}, [pendingTransaction]);

	const handlePayment = async (amount) => {
		presentLoader();
		// const order = await createOrder(params); //  Create order on your backend
		sdrPaymentMode()
			.then(async (resp) => {
				console.log(resp);
				if (resp.data[0].useLinkInCustomerAppForAllotment) {
					console.log("allotmentDetails", allotmentDetails);
					getPaymentLinkMode(allotmentDetails, amount)
						.then((create) => {
							if (create.data.success) {
								getPyamentLink(create.data.paymentLinkId)
									.then((response) => {
										if (response.data.success) {
											setPendingTransaction([]);
											setAllotmentDetails({});
											setShowModal(false);
											successTost("Payment link sent on registered mobile number!");
											// window.open(resp.data.link, '_blank')
											let anchor = document.createElement("a");
											anchor.href = response.data.link;
											anchor.target = "_blank";
											anchor.click();
											dismissLoader();
										} else {
											dismissLoader();
											errorTost("Could not create order!");
										}
									})
									.catch((err) => {
										dismissLoader();
										errorTost("Could not create order!");
									});
							} else {
								dismissLoader();
								errorTost(create.data.message);
							}
						})
						.catch((err) => {
							dismissLoader();
							errorTost("Could not Create Order! Please Try again later");
						});
				} else {
					const obj = {
						amount: amount,
						type: "Allotment",
						transactionObj: {
							amount: amount,
							transactionType: allotmentDetails.pricingType,
							modeOfPayment: "Razorpay-Customer Portal",
							allotmentPaymentId: allotmentDetails.allotmentPaymentId,
							unitId: allotmentDetails?.unitId?.unitId,
							inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId,
							leadId: allotmentDetails.leadId.leadId,
							status: "pending",
						},
					};
					await createPaymentOrder(obj)
						.then(async (order) => {
							if (order?.data?.success) {
								dismissLoader();
								const options = {
									key: process.env.REACT_APP_RAZOR_PAY_KEY, // Enter the Key ID generated from the Dashboard
									amount: amount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
									currency: "INR",
									name: "VJ Developers",
									description: "Payment for allotment " + allotmentDetails?.allotmentPaymentId,
									order_id: order.data.id, //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
									handler: function (response) {
										console.log("response: ", response);
									},
								};
								const rzp1 = new window.Razorpay(options);
								// rzp1.on("payment.failed", function (response) {
								// 	console.log("fail response: ", response);
								// 	// ?todo: show loader modal
								// });
								rzp1.open();
							} else {
								dismissLoader();
								errorTost("Couldn't create order! please try again later");
							}
						})
						.catch((err) => {
							console.log("err: ", err);
							dismissLoader();
							errorTost("Network Error. Please try again later!");
						});
				}
			})
			.catch((err) => {
				dismissLoader();
				errorTost("Payment Failed! Please try again Later");
				console.error("link mode Error", err);
			});
	};
	function allotmentPaymentResponse(value) {
		console.log("value: ", value);
		if (value && value > 0) {
			handlePayment(value);
			setOpenAllotmentPartialPaymentModal(false);
		}
	}

	const [openAlreadyCancelReq, setOpenAlreadyCancelReq] = useState({ value: false, msg: "" });
	const handleCancelReq = async (allotment) => {
		presentLoader();
		console.log("aalotment", allotment);
		await getAllotmentCancelledTransaction(allotment.allotmentPaymentId).then((resp) => {
			console.log("resp", resp)
			if (resp.length > 0) {
				if (resp[0].status === "Pending" && resp[0].leadConfirmation !== "Rejected") {
					setOpenAlreadyCancelReq({ value: true, msg: "Cancel Unit Request currently in Process" });
				} else if (resp[0].status === "Accepted") {
					setOpenAlreadyCancelReq({ value: true, msg: "Cancel Unit Request has already been processed." });
				} else {
					setOpenCancelUnitModal(true);
					setAllotmentDetails(allotment);
				}
				dismissLoader();
			} else {
				setOpenCancelUnitModal(true);
				setAllotmentDetails(allotment);
				dismissLoader();
			}

		})
	}

	return (
		<>
			<Card className={cssClasses.allotmentEventWrap} style={{ borderRadius: "20px", boxShadow: "none" }}>
				<div className={cssClasses.allotmentCardHeader}>
					<div className={cssClasses.allotmentTokenNumWrap}>
						<div className={cssClasses.allotmentImg}>
							<img src={AllotmentBuildingIcon} alt="allotment" />
						</div>
						<div className={cssClasses.allotmentProjectDetail}>
							<div className={cssClasses.allotmentProjectDetailFirst}>
								<span>
									{allotment?.unitId && (
										<span>
											{allotment?.unitId.wingId.displayName
												? allotment?.unitId.wingId.displayName
												: allotment?.unitId.wingId.wingName}{" "}
											- {allotment?.unitId.unitNo}
										</span>
									)}
									{allotment?.inventoryMergedId &&
										((allotment?.inventoryMergedId.unit1Id.wingId.wingId ===
											allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
												<span>
													{allotment?.inventoryMergedId.unit1Id.wingId.displayName
														? allotment?.inventoryMergedId.unit1Id.wingId.displayName
														: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
													- {allotment?.inventoryMergedId.unit1Id.unitNo} & {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
												</span>
											)) ||
											(allotment?.inventoryMergedId.unit1Id.wingId.wingId !==
												allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
													<span>
														{allotment?.inventoryMergedId.unit1Id.wingId.displayName
															? allotment?.inventoryMergedId.unit1Id.wingId.displayName
															: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
														{allotment?.inventoryMergedId.unit2Id.wingId.displayName
															? allotment?.inventoryMergedId.unit2Id.wingId.displayName
															: allotment?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
													</span>
												)))}
								</span>

								<div className={cssClasses.allotmentProjectName}>
									{allotment?.unitId && <span>{allotment?.unitId.projectId.projectName}</span>}
									{allotment?.inventoryMergedId && <span>{allotment?.inventoryMergedId.projectId.projectName}</span>}
								</div>
								{allotment.paymentId?.eventTokenId?.tokenId.isPreselect && (
									<span>
										<LeadStatusChip
											label={"Preselect"}
											style={{
												color: "#FF7B01",
												border: "1px solid #FFC997",
												borderRadius: "0px",
											}}
										></LeadStatusChip>
									</span>
								)}
							</div>
						</div>
					</div>
					<div className={cssClasses.allotmenttimeActionSection}>
						<div className={cssClasses.allotmentTokenLastUpdate}>
							<ReactTimeAgo style={{ fontSize: "1.2rem" }} date={allotment?.last_updated_at ?? allotment?.created_at} locale="en-US" />
						</div>
						<div className={cssClasses.tokenActions}>
							<ThreeDotsMenu
								list={allotment?.menuOpt}
								selectedValue={(e) => {
									console.log(e);
									if (e === "View Details") {
										setAllotmentDetails(allotment);
										setShowDetails(true);
										// setScheduleSiteVisitModal(true);
									} else if (e === "Cancel Unit") {
										handleCancelReq(allotment)
										// setOpenCancelUnitModal(true);
										// setAllotmentDetails(allotment);
									}
								}}
							/>
						</div>
					</div>
				</div>
				<div style={{ width: "100%" }}>
					<div className={cssClasses.tokenStatus}>
						{allotment?.status === "Payment Complete" || allotment?.status === "Agreement Done" ? (
							<>
								{allotment.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "Cancelled" ||
									allotment.status === "Change Requested" ||
									allotment.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
								{/* ? if 5,00,000 amount is paid; check for SDR amount */}
								{allotment?.paidAmt?.sdr >= (allotment?.unitCost?.sdr) ? (
									<LeadStatusChip
										label={"SDR Complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
									></LeadStatusChip>
								) : (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
									></LeadStatusChip>
								)}
								{!allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.kycFormFilled && (
									<LeadStatusChip
										label={"KYC Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}

								{allotment.preselectConfirmation === "confirmation pending" && (
									<LeadStatusChip
										label={"Confirmation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
							</>
						) : (
							<>
								{allotment?.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment?.status === "cancelled" ||
									allotment?.status === "Cancelled" ||
									allotment?.status === "Cancellation Rejected" ||
									allotment?.status === "Change Requested" ||
									allotment?.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment?.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
								{allotment?.status === "Partial Payment Done" && (
									<LeadStatusChip
										label={allotment?.isCrm2 ? "Shortlisted · Partial Payment" : allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{allotment?.status === "Payment Pending" && (
									<LeadStatusChip
										label={allotment?.isCrm2 ? "Shortlisted · Payment Pending" : "Payment Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B42318",
											backgroundColor: "#FEF3F2",
										}}
									></LeadStatusChip>
								)}
								{allotment?.status === "expired" && (
									<LeadStatusChip
										label={"Expired"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment?.status === "On Hold" && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#3538CD",
											backgroundColor: "#EEF4FF",
										}}
									></LeadStatusChip>
								)}
								{(allotment?.status === "Released" ||
									allotment?.status === "Refund Processed" ||
									allotment?.status === "Refund Initiated") && (
										<LeadStatusChip
											label={allotment?.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "rgb(180, 35, 24)",
												backgroundColor: "rgb(254, 243, 242)",
											}}
										></LeadStatusChip>
									)}
								{allotment?.status === "Partial Payment Done" && !allotment?.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment?.kycFormFilled && (
									<LeadStatusChip
										label={"KYC Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
							</>
						)}
						{allotment?.leadId?.LeadsReferral.length>0 && allotment?.leadId?.LeadsReferral[0]?.id && 
										<LeadStatusChip
											label="VJOP"
											style={{
												color: "rgb(180, 35, 24)",
												backgroundColor: "rgb(254, 243, 242)",
											  }}
										></LeadStatusChip>
									}
					</div>
				</div>
				<div className={cssClasses.allotmentCpDetails}>
					<div className={cssClasses.allotmentCpDetailsContent}>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>VJ Sales Manager : </div>
								<div>{loggedInUser?.userId?.name ?? "NA"}</div>
							</div>
						</div>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>FOS : </div>
								<div>{loggedInUser?.fosId?.name ?? "NA"}</div>
							</div>
						</div>
					</div>
					<Divider orientation="vertical" variant="middle" flexItem />
					{/* <Divider orientation="vertical" variant="middle" flexItem /> */}
					<div className={cssClasses.allotmentCpDetailsContent}>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>Channel Partner : </div>
								<div>{loggedInUser?.cpId?.billingName ?? "NA"}</div>
							</div>
						</div>
					</div>
				</div>
				<div className={cssClasses.allotmentCardData}>
					<div className={cssClasses.allotmentCardDetails}>
						<div className={cssClasses.allotmentEventData}>
							<div className={cssClasses.allotmentTokenData}>
								<span className={cssClasses.AllotmentEventName}>{allotment?.paymentId?.eventTokenId?.eventId?.title}</span>
							</div>
							<div className={cssClasses.allotmentUnitDetails}>
								{allotment?.unitId?.inventoryTypeId?.type &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Inventory Type") ? (
									<span>{allotment?.unitId?.inventoryTypeId?.type} • </span>
								) : (
									""
								)}
								{allotment?.unitId?.displayUnitType &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Display Unit Type") ? (
									<span>{allotment?.unitId?.displayUnitType} • </span>
								) : (
									""
								)}
								{/* } */}
								{allotment?.inventoryMergedId && (
									<>
										{/* {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type === allotment.inventoryMergedId.unit2Id.inventoryTypeId.type &&
                                                    <span>{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type}</span>
                                                }
                                                {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type !== allotment.inventoryMergedId.unit2Id.inventoryTypeId.type && */}
										<span>
											{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type} -{" "}
											{allotment.inventoryMergedId.unit2Id.inventoryTypeId.type}
										</span>
										{/* } */}
									</>
								)}

								{allotment?.unitId && <span>{allotment?.unitId?.floorNo}</span>}
								<span>{" • "}</span>
								{allotment.unitId && (
									// <span>Area {allotment.unitId.chargeableArea} sq.ft</span>
									<span>Area {allotment?.unitId?.saleableArea} sq.ft</span>
								)}
								{allotment.inventoryMergedId && (
									<>
										{allotment.inventoryMergedId.unit1Id.floorNo === allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>{allotment.inventoryMergedId.unit1Id.floorNo}</span>
										)}
										{allotment.inventoryMergedId.unit1Id.floorNo !== allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>
												{allotment.inventoryMergedId.unit1Id.floorNo} - {allotment.inventoryMergedId.unit2Id.floorNo}
											</span>
										)}
									</>
								)}
								{allotment.inventoryMergedId && (
									<>
										<span>
											Area {allotment.inventoryMergedId.unit1Id.saleableArea} +{" "}
											{allotment.inventoryMergedId.unit2Id.saleableArea} sq.ft
										</span>
									</>
								)}
							</div>
						</div>
						<div className={cssClasses.allotmentDateContent}>
							<div className={cssClasses.allotmentDateData}>
								<img src={AllotmentCalenderIcon} alt="Calender-check" />
								Alloted On:{" "}
							</div>
							<div className={cssClasses.allotmentDate}>
								{new Date(allotment.created_at).toDateString()},{" "}
								{new Date(allotment.created_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</div>
						</div>
					</div>
					<div className={cssClasses.allotmentPriceBreakDown}>
					{	  (allotment?.isOnlineBooking ?( isTimerFinished || allotment.status === "Payment Complete" ) : true)
					&&(<><div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								OCR :
								<img data-tooltip-id="ocr" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="ocr" content="Overall Capitalization Rate" />
							</div>
							<div>₹ {numberWithCommas(allotment.bookingAmt?.ocr)}</div>
						</div>
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								SDR :
								<img data-tooltip-id="sdr" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="sdr" content="Stamp Duty Registration" />
							</div>
							<div>₹ {numberWithCommas(allotment.bookingAmt?.sdr)}</div>
						</div>
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								GST :
								<img data-tooltip-id="gst" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="gst" content="Goods & Services Tax" />
							</div>
							<div>₹ {numberWithCommas(allotment.bookingAmt?.gst)}</div>
						</div>
						<Divider orientation="vertical" flexItem style={{ borderWidth: "1px" }} /></>)}
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								Booking Amount:
								<img data-tooltip-id="booking-amt" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="booking-amt" content="Booking Amount" />
							</div>
							<div className={cssClasses.allotmentTotalAmount}>
								<span>₹ {numberWithCommas(allotment?.bookingAmt?.total)}</span>
								{/* {!allotment.paymentId?.eventTokenId.tokenId.isPreselect && (
									<span>₹ {numberWithCommas(allotment?.bookingAmt?.total)}</span>
								)}
								{allotment.paymentId?.eventTokenId.tokenId.isPreselect && (
									<span>₹ {numberWithCommas(allotment.paymentId?.eventTokenId.tokenId.amount)}</span>
								)} */}
							</div>
						</div>
					</div>
					{/* <div>{allotment?.unitId?.projectId?.projectId === "35f4da59-a818-451c-ba07-baed8b46614d" && allotment?.unitId?.wingId?.wingId === "3d98f1b1-af93-4168-b8f3-cf9058fb4d74" && allotment?.priceDiscountAmount > 0 && allotment?.isDiscountEligible && (
						<div style={{ padding: "1rem", fontSize: "1.8rem", lineHeight: "2.8rem" }}>
							<div><span style={{ fontWeight: "bold" }}>Congratulations !</span> You are eligible for group buying discounts. Your discount amount is <span style={{ fontWeight: "bold" }}> ₹ {numberWithCommas(allotment?.priceDiscountAmount)}</span> </div>
						</div>
					)}
					</div> */}
				</div>

				{(crm2State === "SHORTLISTED" || crm2State === "WAITING_RM") && (
					<div className={crm2Css.wrap}>
						{crm2State === "SHORTLISTED" ? <ShortlistedSteps allotment={allotment} info={crm2} /> : <WaitingForRm info={crm2} />}
					</div>
				)}

				<div className={cssClasses.allotmentsCardFooter}>
					<div className={cssClasses.allotmentpaidAmtContent}>
						<div>PAID AMOUNT </div>
						<div className={cssClasses.allotmentpaidAmt}>₹ {numberWithCommas(allotment.paidAmount)}</div>
					</div>
					{
					 (allotment.status === "Payment pending" || allotment.status === "Payment Pending" || allotment.status === "Partial payment done" || allotment.status === "Partial Payment Done") && allotment.isOnlineBooking  && allotment.status !== "Payment Complete" && !isTimerFinished &&
					( <div
  style={{
    backgroundColor: "#FFE5E5",
    border: "1px solid #FF4D4D",
    borderRadius: "8px",
     padding: "0px 15px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontFamily: "Inter-Medium, sans-serif",
    width: "fit-content",
  }}
>
  <div
    style={{
        color: "#B00020",
      fontSize: "1.5rem",
      fontWeight: 400,
      
    }}
  >
    Expires In
  </div>

  {/* Timer Boxes */}
  {timeRemaining && !isTimerFinished ? (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Extract minutes and seconds from your existing timeRemaining string */}
      <div
        style={{
        
          color:"#FF4D4D",
          borderRadius: "6px",
        //   padding: "6px 12px",
          fontSize: "2.4rem",
          fontWeight: "bold",
          textAlign: "center",
          minWidth: isMobile?"35px":"40px",
        }}
      >
        {String(timeRemaining.split("min")[0]).trim()}<span style={{fontSize:"1.8rem",fontWeight:"normal"}}>min</span>
      </div>
      <div style={{ color: "#B00020", fontWeight: "bold", fontSize: "2.3rem",padding:"0px 5px" }}>
        :
      </div>
      <div
        style={{
     
          color: "#FF4D4D",
          borderRadius: "6px",
        //   padding: "6px 12px",
          fontSize: "2.4rem",
          fontWeight: "bold",
          textAlign: "center",
          minWidth: isMobile?"35px":"40px",
        }}
      >
        {String(timeRemaining.split(":")[1]).replace("sec", "").trim()}<span style={{fontSize:"1.8rem",fontWeight:"normal"}}>sec</span>
      </div>
    </div>
  ) : (
   <></>
  )}
</div>
)}
					<div className={cssClasses.allotmentActionBtnWrap}>
						<div className={cssClasses.allotmentBtnView}>
							<Button
								btnName={"View Unit Cost"}
								clicked={() => setShowUnitCost(true)}
								style={{
									color: "#344054",
									backgroundColor: "#FFFFFF",
									fontSize: "1.4rem",
									lineHeight: "2rem",
									fontFamily: "Inter-Medium !important",
								}}
							></Button>
						</div>
					
						{(
  (allotment.status === "Payment Pending" || allotment.status === "Partial Payment Done") &&
  (
    (allotment?.isOnlineBooking && !isTimerFinished) ||
    !allotment?.isOnlineBooking
  )
)
&&(
							// !allotment.paymentId?.eventTokenId?.tokenId?.isPreselect && (
							<><div className={cssClasses.paidAmt}>
								{!kycFirstPayNowHidden(allotment.kycFormFilled, esignFlow) && (
								<Button
									btnName={"Pay Now"}
									 disabled={allotment?.isOnlineBooking  && isTimerFinished}
									clicked={() => {
										if (allotment?.isOnlineBooking  && isTimerFinished) return;
										const pay = () => requireConsent(CONSENT_TYPES.ALLOTMENT, () => {
											setOpenAllotmentPartialPaymentModal(true);
											setShowModal(true);
											setAllotmentDetails(allotment);
										}, { summary: allotmentConsentSummary(allotment) });
										// old flow: unchanged; new flow or unknown: the server decides on eSign first
										if (!payNowNeedsEsign(esignFlow)) return pay();
										requireEsign(allotment.allotmentPaymentId, pay, { summary: allotmentConsentSummary(allotment) });
									}}
									style={{
										color: "#fff",
										backgroundColor:allotment?.isOnlineBooking  && isTimerFinished?"gray": "rgb(21, 112, 239)",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										fontFamily: "Inter-Medium !important",
									}}
								></Button>
								)}
								{kycFirstPayNowHidden(allotment.kycFormFilled, esignFlow) && (
									<div style={{ fontSize: "1.2rem", color: "#B42318", marginTop: "0.4rem", whiteSpace: "nowrap" }}>
										{KYC_FIRST_TEXT}
									</div>
								)}
							</div>
							</>
						)}
						{
  !allotment.kycFormFilled &&
  // CRM 2.0: the Agreement KYC opens after the Relationship Manager is assigned (M2-F9)
  !(allotment?.isCrm2 && crm2State !== "APPLIED") &&
  allotment.status !== "Cancelled" &&
  allotment.status !== "Refund Processed" &&
  allotment.status !== "Released" &&
  allotment.status !== "Refund Initiated" &&
  (allotment?.isOnlineBooking ?( isTimerFinished || allotment.status === "Payment Complete" ) : true)

 &&(
								<div className={cssClasses.paidAmt}>
									<Button
										btnName={kycButtonLabel(esignFlow)}
										clicked={() => {
											setCurrentAllotmentPayment(allotment);
											setOpenBookingFormModal(true);
										}}
										style={{
											color: "#fff",
											backgroundColor: "rgb(21, 112, 239)",
											fontSize: "1.4rem",
											lineHeight: "2rem",
											fontFamily: "Inter-Medium !important",
										}}
									></Button>
								</div>
							)}
					</div>
				</div>
			</Card>
			{showDetails && (
				<AllotmentDetails
					open={showDetails}
					handleClose={() => {
						setAllotmentDetails({});
						setShowDetails(false);
					}}
					data={allotmentDetails}
				/>
			)}
			{openCancelUnitModal && (
				<CancelUnit
					open={openCancelUnitModal}
					handleClose={() => {
						setOpenCancelUnitModal(false);
					}}
					allotmentDetails={allotmentDetails}
				/>
			)}
			{consentModal}
			{esignModal}
			{crm2 && <Crm2PaymentSuccess allotment={allotment} info={crm2} />}
			{openAllotmentPartialPaymentModal && (
				<AllotmentPayment
					allotmentDetails={allotmentDetails}
					pendingTransaction={pendingTransaction}
					setPendingTransaction={setPendingTransaction}
					setAllotmentDetails={setAllotmentDetails}
					open={openAllotmentPartialPaymentModal}
					allotmentPaymentResponse={allotmentPaymentResponse}
					setOpenPaymentGatewaySelectionModal={setOpenPaymentGatewaySelectionModal}
					payableAmount={payableAmount}
					setPayableAmount={setPayableAmount}
					handleClose={() => {
						setPendingTransaction([]);
						setAllotmentDetails({});
						setShowModal(false);
						setOpenAllotmentPartialPaymentModal(false);
					}}
				/>
			)}
			{
				openPaymentGatewaySelectionModal && (
						<PaymentGatewaySelection
							open={openPaymentGatewaySelectionModal}
							onClose={() => {
								setOpenPaymentGatewaySelectionModal(false);
							}}
							allotmentPaymentResponse={allotmentPaymentResponse}
							payableAmount={payableAmount}
							allotmentDetails={allotmentDetails}
							type={"allotment"}
						/>
					)
			}
			{openBookingFormModal && (
				<BookingForm
					allotment={currentAllotmentPayment}
					open={openBookingFormModal}
					handleClose={() => {
						setOpenBookingFormModal(false);
					}}
				/>
			)}
			{showUnitCost && (
				<UnitCost
					allotment={allotment}
					open={showUnitCost}
					handleClose={() => {
						setShowUnitCost(false);
					}}
				/>
			)}
			{openAlreadyCancelReq && (
				<ConfirmationAlert
					close={() => {
						setOpenAlreadyCancelReq({ value: false, msg: "" });
						window.location.reload();							// handleClose();
					}}
					open={openAlreadyCancelReq.value}
					buttonTitle={"Cancel"}
					title={"Warning"}
					subTitle={openAlreadyCancelReq.msg}
					confirm={(e) => {
						setOpenAlreadyCancelReq({ value: false, msg: "" });
						window.location.reload();
					}}
				/>
			)}
		</>
	);
};

export default Allotment;
